import strFunc from "@/lib/lyg/string";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

function KatalSendArea(props: any) {
  let myProps = {
    stu_info: {},
    stu_info_arr: [],
    set_stu_info_arr: (inData: any) => { },
    open_send_local_katalk_counsel_todo_popup: (inData: any) => { },
    last_counsel_info: null,
    ...props
  };
  let stu_info = myProps.stu_info;

  const on_change_input_add_memo = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_stu_info = { ...stu_info };
    if (change_stu_info.add_memo_info) {
      change_stu_info.add_memo_info[name] = value;
    } else {
      change_stu_info.add_memo_info = { [name]: value };
    }
    if (name == "a_kakaotalk_parent_room_name") {
      write_memo_by_ajax({ add_memo_info: { [name]: value } });
    }
    let change_stu_info_arr = [...myProps.stu_info_arr];
    for (let i = 0; i < change_stu_info_arr.length; i++) {
      if (change_stu_info_arr[i]["a_seq"] == stu_info["a_seq"]) {
        change_stu_info_arr[i] = change_stu_info;
        break;
      }
    }
    myProps.set_stu_info_arr(change_stu_info_arr);
  };

  const write_memo_by_ajax = (inData: any) => {
    let opt_obj = {
      add_memo_info: {},
      ...inData
    };
    let stu_add_memo_info = {
      a_mcomp_seq: stu_info.a_mcomp_seq,
      a_user_seq: stu_info.a_seq,
      a_kakaotalk_parent_room_name: "",
      ...opt_obj.add_memo_info
    };
    if (strFunc.is_empty(stu_add_memo_info.a_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(stu_add_memo_info.a_user_seq)) {
      return false;
    }

    let form_json_data: any = {
      data_arr: [stu_add_memo_info],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_add_memo/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {

        } else {
          alert(response.data["msg"]);
        }
      });
  };

  let chat_room_name = "";
  if (stu_info && stu_info.add_memo_info) {
    chat_room_name = stu_info.add_memo_info.a_kakaotalk_parent_room_name;
  }

  return (
    <div>
      방이름
      <input type="text" className="row-input ml-1" value={chat_room_name}
        name="a_kakaotalk_parent_room_name"
        onChange={on_change_input_add_memo}
        title="카카오톡 방이름"
        autoComplete="off"
        style={{ width: "130px" }} />
      {myProps.last_counsel_info != null &&
        <button className="btn btn-yellow ml-1"
          onClick={() => {
            myProps.open_send_local_katalk_counsel_todo_popup({
              select_counsel_info_arr: [myProps.last_counsel_info]
            });
          }}
        >카톡전송</button>
      }
    </div>
  );
};
export default KatalSendArea;